import { Navigate, Outlet } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import { usePublicForm } from 'hooks/module/Form';
import FullLoader from './Loader/FullLoader';
import { usePrototypeTokenReceiver } from '../hooks/module';

function NonUserRoute() {
  const { isAuthenticated, loading } = useAuth();
  const { isProcessingMessage, receivedToken } = usePrototypeTokenReceiver();
  const { getRequiredDataFromURL } = usePublicForm();
  const { fromQR, linkID, hasPrefill, formID } = getRequiredDataFromURL();

  if (loading || isProcessingMessage || (receivedToken && !isAuthenticated))
    return <FullLoader />;
  if (isAuthenticated && fromQR) {
    return (
      <Navigate
        to={`/forms/form-results/add-response/${formID}?from_QR=${fromQR}?link_id=${linkID}?has_prefill=${hasPrefill}`}
        replace
      />
    );
  }

  return !isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
}

export default NonUserRoute;
